const resetAll = () => {

    document.getElementById('search-field').value = ''; //searchbox
    document.getElementById('career-filter').value = 0; //career dropdown
    document.getElementById('degree-filter').value = 0; //degree dropdown
    const filterResults       = document.querySelector('.program-listing--filter--results__career__value')
    const degreeResults       = document.querySelector('.program-listing--filter--results__degree__value')

    if( filterResults ) {
        filterResults.remove(); 
    }
    if( degreeResults ) {
        degreeResults.remove(); 
    }

    document.getElementById('program-listing--filter--results--hook').style.display = 'none';

    searchFilter();
}

const deleteDropdownFilter = () => {  

    const careerDropdownValue = document.querySelector('.program-listing--filter--results__career__value');
    const degreeDropdownValue = document.querySelector('.program-listing--filter--results__degree__value');

    if( careerDropdownValue ) {
        careerDropdownValue.addEventListener('click', (e) => {
            e.target.remove();
            document.getElementById('career-filter').value = 0; 
            if (document.getElementById('degree-filter').value === "0") {
                document.getElementById('program-listing--filter--results--hook').style.display = 'none';
            }
            searchFilter();
        });
    } 

    if( degreeDropdownValue ) {
        degreeDropdownValue.addEventListener('click', (e) => {
            e.target.remove();
            document.getElementById('degree-filter').value = 0; 
            if (document.getElementById('career-filter').value === "0") {
                document.getElementById('program-listing--filter--results--hook').style.display = 'none';
            }
            searchFilter();
        });
    }

}

 
const searchFilter = () => {    

    const search         = document.getElementById('search-field').value; //searchbox
    const careerDropdown = document.getElementById('career-filter').value; //career dropdown
    const degreeDropdown = document.getElementById('degree-filter').value; //degree dropdown
    const data           = new FormData(); //formdata object

    if( search !== 0 ) {
        data.append('search', search); //append search to formdata object
    }
    if( careerDropdown !== 0 ) {
        data.append('career', careerDropdown); //append career to formdata object
    }

    if( degreeDropdown !== 0 ) {    
        data.append('degree', degreeDropdown); //append degree to formdata object
    }

    data.append('action', 'program_listing_filter'); //append action parameter  
  
    fetch(PHP_VARS.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        body: data
    })
    .then((response) => response.json())
    .then((response) => {
       
        // program count
        const programCount = document.querySelector('.program-listing--programs__header');
        programCount.innerHTML = '';    
        if( response.length > 0 ) {
        programCount.innerHTML += `
            <span class="program-listing--programs__count">Found <em>${response.length}</em>&nbsp; Programs</span>
        `;
        } else {
            programCount.innerHTML += ``;
        }


        // program listing (Cards)
        const programList = document.querySelector('.program-listing--programs .program-listing--programs__results .row');
        programList.innerHTML = '';
        //if there is a response from the server show it else show no results
        if(response.length > 0) {
            response.forEach((program) => {
                programList.innerHTML += `
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <div class="program-listing--programs__item d-flex flex-column">
                        <div class="program-listing--programs__item__color  ${program.slug[0]}"></div>
                        <div class="program-listing--programs__item__image">
                            <img src="${program.image}" alt="${program.title}">
                        </div>
                        <div class="program-listing--programs__item__content d-flex flex-column align-items-start">
                            <span class="program-listing--programs__item__title">${program.title}</span>
                            <span class="program-listing--programs__item__degree">${program.degree[0]}</span>
                            <div class="program-listing--programs__item__excerpt">
                                <p>${program.excerpt}</p>
                            </div>
                            <a href="${program.permalink}" class="program-listing--programs__item__button mt-auto">View Major<span class="visually-hidden">: ${program.title}<span></a>
                        </div>
                    </div>
                </div>
                `;
               
            })
        } else {
            programList.innerHTML = '<div class="program-listing--programs__results__no-results"><h2 class="program-listing--programs__results__no-results__title">No Academic Programs Found</h2><p>We couldn\'t find any academic programs that match your search criteria. Please try refining your search terms or explore our catalog for available programs.</p></div>';
        }
    
    })    
}

const search         = document.getElementById('search-field') 
const careerDropdown = document.getElementById('career-filter') 
const degreeDropdown = document.getElementById('degree-filter')

const clearButton    = document.getElementById('clear-all');

let typingTimer;
const typeInterval = 500;

if ( search ) {
    search.addEventListener("keyup", () => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(searchFilter, typeInterval)
    });
}
if( careerDropdown || degreeDropdown ) {
    window.addEventListener('change', searchFilter)
}

if( clearButton ) {
    clearButton.addEventListener('click', resetAll)
}

 



    
//on change get degree dropdown text


let degreeDropdownValue = document.getElementById('degree-filter')?.value || '';
let degreeDropdownText  = document.querySelector('#degree-filter option[value="'+degreeDropdownValue+'"]')?.text || '';    
degreeDropdown?.addEventListener('change', () => {
    degreeDropdownValue = document.getElementById('degree-filter').value;
    degreeDropdownText  = document.querySelector('#degree-filter option[value="'+degreeDropdownValue+'"]').text;
    const degreeDropdownLabel = document.querySelector('.program-listing--filter--results__degree');
    degreeDropdownLabel.innerHTML = '';
    if( degreeDropdownValue !== 0 ) {
        degreeDropdownLabel.innerHTML += `
            <span class="program-listing--filter--results__degree__label">Degree Type:</span>
            <span class="program-listing--filter--results__degree__value">${degreeDropdownText}</span>
        `;
        document.getElementById('program-listing--filter--results--hook').style.display = 'flex';
    } else {
        degreeDropdownLabel.innerHTML += `Degree Type:`;
    }
    
    deleteDropdownFilter();
})

//on change get career dropdown text
let careerDropdownValue = document.getElementById('career-filter')?.value || '';
let careerDropdownText  = document.querySelector('#career-filter option[value="'+careerDropdownValue+'"]')?.text || '';
 
careerDropdown?.addEventListener('change', () => {
    careerDropdownValue = document.getElementById('career-filter').value;
    careerDropdownText  = document.querySelector('#career-filter option[value="'+careerDropdownValue+'"]').text;
    const careerDropdownLabel = document.querySelector('.program-listing--filter--results__career');
    careerDropdownLabel.innerHTML = '';
    if( careerDropdownValue !== 0 ) {
        careerDropdownLabel.innerHTML += `
            <span class="program-listing--filter--results__career__label">Career Community:</span>
            <span class="program-listing--filter--results__career__value">${careerDropdownText}</span>
        `;
        document.getElementById('program-listing--filter--results--hook').style.display = 'flex';
    } else {
        careerDropdownLabel.innerHTML += `Career Community:`;
    }
    
    deleteDropdownFilter();
})


 